
import Typography from "@mui/material/Typography";
import noData from '../../../assets/images/nodata.png';
import "./noSearchData.scss";

const NoSearchData = () => {
    return ( 
        <Typography className="noData-search-blk" component={'div'}>
            <Typography component={'div'}>
                <img src={noData} alt="No Data Found" className="no-data-img" />
                <Typography component={'div'} className="no-data-msg">No data found</Typography>
            </Typography>
        </Typography>
    )
}

export default NoSearchData ;
